import React, { useEffect, useState } from 'react'
import Network from '../utils/Network'

type Props = {}

const useEventBannerShop = () => {
  const axios = new Network()
  const [eventBannerShop, setEventBannerShop] = useState<any>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)



  

  const getEventBannerShop = async () => {
    setLoading(true)
    try {
      const response = await axios.CallApi({
        url: '/quest/eventbannershop',
        method: 'GET',
      })
      setEventBannerShop(response.data)
    } catch (error) {
      setError(error as string)
    }
  }

  useEffect(() => {
    getEventBannerShop()
  }, [])

  return {
    eventBannerShop,
    loading,
    error,
    getEventBannerShop,
  }
}

export default useEventBannerShop